import { C as CosmosSelectValue$1, d as defineCustomElement$1 } from './p-BvfBQm0c.js';

const CosmosSelectValue = CosmosSelectValue$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosSelectValue, defineCustomElement };
